import { type DescMethod } from '@bufbuild/protobuf';
import { checkRpcPermissions, type PermissionsCombinator } from '@/api/permissions';
import { useEffectivePermissions } from '@/routes/_authenticated.hooks';
import { type NonEmptyArray } from '@/utils/types';

/**
 * Checks whether the current account may call the given RPC methods, using the permissions each method
 * declares in its proto options. Privileges are not RPC permissions — those go through
 * `usePrivilegeAccessControl`.
 *
 * Backed by `checkRpcPermissions`, the same helper the Connect permissions interceptor uses to gate
 * the actual calls, so the UI and the transport can never disagree.
 */
export function useRpcPermissions(
  methods: NonEmptyArray<DescMethod>,
  combinator: PermissionsCombinator = 'allOf',
): { matches: boolean; missingPermissions: string[] } {
  const currentPermissions = useEffectivePermissions();

  return checkRpcPermissions(methods, currentPermissions, combinator);
}
